export function containsOnlyNumbers(str) {
  return /^[0-9]\d*(\.\d+)?$/.test(str);
}

export function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
